import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'la-values-table',
    imports: [CommonModule],
    template: `
    <div class="h3">{{ data.title }}</div>
    <table>
      <thead>
        <th
          *ngFor="let labelValue of data.entries[0]; first as isFirst"
          class="fw-b"
          [class.text-end]="alignValues === 'end' && !isFirst"
          >{{ labelValue?.label || '-' }}</th
        >
      </thead>
      <tbody>
        <tr *ngFor="let row of data.entries">
          <td
            *ngFor="let labelValue of row; first as isFirst"
            class="fw-b"
            [class.text-end]="alignValues === 'end' && !isFirst"
            >{{ labelValue?.value || '-' }}</td
          >
        </tr>
      </tbody>
    </table>
  `,
    styles: [
        `
      table {
        width: 100%;
        border-collapse: collapse;
        page-break-inside: avoid;
      }

      th,
      td {
        text-align: start;
      }
      table tr:first-child {
        border-top: var(--table-border-top);
      }

      table tr:not(:last-child) {
        border-bottom: var(--table-border);
      }

      table th {
        padding: 0 8px;

        &:first-child {
          padding-left: 0;
        }
      }

      table td {
        padding: 8px;
        font-size: 10pt;
        vertical-align: top;

        &:first-child {
          padding-left: 0;
          width: 50%;
        }
      }

      table tr.summary-row {
        background-color: #fff;
        border-top: 2px solid #00aeef;
        font-weight: 700;
      }
    `,
    ]
})
export class ValuesTableComponent {
  @Input() data: {
    title: string;
    entries: { label: string; value: string }[][];
  } = {
    title: '',
    entries: [],
  };
  @Input() alignValues: 'start' | 'end' = 'start';
}
